export default __webpack_public_path__ + "e42df9a.png";